import React, { createContext, useMemo, useState } from "react";

export const ExtractAudienceDataContext = createContext({});

export function ExtractAudienceDataProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(false);
  const [awaitingResponse, setAwaitingResponse] = useState(false);
  const [awaitingData, setAwaitingData] = useState(false);
  const [responseSuccess, setResponseSuccess] = useState(false);
  const [fileSegments, setFileSegments] = useState({});
  const [selectableSubSegments, setSelectableSubSegments] = useState({});
  const [dataResponseMessage, setDataResponseMessage] = useState("");
  const [fileTotals, setFileTotals] = useState({});
  const [fetchingAudienceActivationStats, setFetchingAudienceActivationStats] =
    useState(false);

  const props = useMemo(
    () => ({
      open,
      setOpen,
      message,
      setMessage,
      awaitingResponse,
      setAwaitingResponse,
      awaitingData,
      setAwaitingData,
      dataResponseMessage,
      setDataResponseMessage,
      responseSuccess,
      setResponseSuccess,
      fileSegments,
      setFileSegments,
      selectableSubSegments,
      setSelectableSubSegments,
      fileTotals,
      setFileTotals,
      fetchingAudienceActivationStats,
      setFetchingAudienceActivationStats,
    }),
    [
      open,
      message,
      awaitingResponse,
      awaitingData,
      dataResponseMessage,
      responseSuccess,
      fileSegments,
      selectableSubSegments,
      fileTotals,
      fetchingAudienceActivationStats,
      setFetchingAudienceActivationStats,
    ]
  );

  return (
    <ExtractAudienceDataContext.Provider value={props}>
      {children}
    </ExtractAudienceDataContext.Provider>
  );
}
